module.exports = new __parcel__URL__("hand-edit-icon.0cb414cb.svg").toString();